import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import employeeAPIService from "./employeeAPIService"

const initialState={
   employees:[],
   isError:false,
   isLoading:false,
   isSuccess:false,
   message: '',
};


// // update employee status
// export const updateEmployeeStatus = createAsyncThunk(
//     'employees/updateStatus',
//     async ({ employeeId, status }, thunkAPI) => {
//       try {
//         const updatedEmployee = await employeeAPIService.updateEmployeeStatus(employeeId, status);
//         thunkAPI.dispatch(setEmployeeStatus(updatedEmployee));
//         return updatedEmployee;
//       } catch (error) {
//         const message =
//           (error.response &&
//             error.response.data &&
//             error.response.data.message) ||
//           error.message ||
//           error.toString();
  
//         return thunkAPI.rejectWithValue(message);
//       }
//     }
//   );




//get all employees
export const getEmployees = createAsyncThunk(
    //action type string
    'employees/getAll',
    async(_,thunkAPI)=>{
        try {
            const employees = await employeeAPIService.getEmployees();
            thunkAPI.dispatch(setEmployees(employees));
            return employees;
            
            
            
            // return await employeeAPIService.getEmployees();
        } catch (error) {
            const message =
                (error.response && 
                error.response.data && 
                error.response.data.message) ||
                error.message ||
                error.toString();

            return thunkAPI.rejectWithValue(message);  
        }
    }
);


export const employeeSlice = createSlice({
    name: 'employees',
    initialState,
    reducers:{
        reset: (state)=> initialState,
        setEmployees: (state, action) => {
            const initialEmployees = action.payload.map((employee) => {
              if(!employee.hasOwnProperty('show')){
                  let status=null;
                  if (employee.get_employee_status !== '') {
                    status = employee.get_employee_status;
                }
                return { ...employee, show: true, status };
              }
              return employee;
            });
            state.employees = initialEmployees;
          },
        updateEmployeeShow: (state, action) => {
            const { id } = action.payload;
            state.employees.forEach((employee) => {
              employee.show = employee.id === id;
            });
          },
        updateEmployeeStatus: (state, action) => {
            const { id } = action.payload;
            state.employees.forEach((employee) => {
              employee.status = employee.id === id;
            });
          },
        resetEmployeeShow: (state, action) => {
            state.employees.forEach(employee => {
                employee.show = action.payload;
            });
          },
    },
    extraReducers: (builder)=>{
        builder 
            .addCase(getEmployees.pending, (state)=>{
                state.isLoading = true;
            })
            .addCase(getEmployees.fulfilled , (state, action)=>{
                state.isLoading = false;
                state.isSuccess = true;
                // state.employees = action.payload;
                // state.push(...action.payload);
            })
            .addCase(getEmployees.rejected , (state, action)=>{
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(resetEmployeeShow, (state, action) => {
                setEmployees(state, { payload: action.payload });
              })

    },
});

export const {setEmployees, reset, updateEmployeeShow, updateEmployeeStatus,resetEmployeeShow}= employeeSlice.actions;
export default employeeSlice.reducer;